(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const meetBlocksArr = document.querySelectorAll('.pattern--home-team');

		meetBlocksArr.forEach(pattern => {

			const cardsArr = pattern.querySelectorAll('.trusler-block--business-card');
		  
			cardsArr.forEach( card => {
				ParcelFunctions.inViewport(card, 0.3, 0.15, 'card-in-viewport');
			})

		});				

	});

})(jQuery);